export const isAppV2Enabled = !["production", "demo"].includes(
  import.meta.env["VITE_TARGET_ENV"] as string,
);
